<template>
  <Layout>
    <PageHeader :title="title" :subTitle="subTitle">
      <template #afterTitle>
        <div class="d-flex align-items-center gap-3">
          <McButtonBack href="/delivery" />
          <McListDownloader
            v-if="$route.name === 'Delivery Import Result'"
            :pageOptions="downloadPageOptions"
            :fileFormatOptions="['excel']"
            :disabled="!importResult"
            @download="handleDownload"
          />
        </div>
      </template>
    </PageHeader>

    <McWizard
      withNumber
      class="mc-wizard mb-4"
      :activeKey="activeWizardImport"
      :items="wizardItems"
    />

    <router-view />
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import McButtonBack from '@/components/McButtonBack'
import McWizard from '@/components/McWizard'
import McListDownloader from '@/components/McListDownloader'
import { mapState } from 'vuex'

export default {
  page: {
    title: 'Delivery',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    McWizard,
    McListDownloader,
  },
  data() {
    return {
      activeWizardImport: 'upload-content',
      metadata: null,
    }
  },
  computed: {
    ...mapState('delivery', ['importResult']),
    title() {
      return this.$t('delivery.upload.title')
    },
    subTitle() {
      return this.$t('delivery.upload.subtitle')
    },
    wizardItems() {
      return [
        { key: 'upload-content', label: this.$t('global.action.upload') },
        { key: 'process-content', label: this.$t('global.action.process') },
        { key: 'result-content', label: this.$t('global.action.result') },
      ]
    },
    downloadPageOptions() {
      return [
        { label: 'Semua', amount: this.importResult?.total_count, key: 'all' },
        { label: 'Data Gagal', amount: this.importResult?.failed_count, key: 'failed' },
        { label: 'Data Berhasil', amount: this.importResult?.success_count, key: 'success' },
      ]
    },
  },
  watch: {
    '$route.name': {
      handler(value) {
        this.handleActiveWizard(value)
      },
      immediate: true,
    },
  },
  methods: {
    handleActiveWizard(routeName) {
      if (routeName === 'Delivery Import') {
        this.activeWizardImport = 'upload-content'
        return
      }

      if (routeName === 'Delivery Import Detail') {
        this.activeWizardImport = 'process-content'
        return
      }

      this.activeWizardImport = 'result-content'
    },
    handleDownload(format, statusType) {
      const params = { format, page: 1, limit: Number.MAX_SAFE_INTEGER }

      if (statusType !== 'all') {
        params['filters[]'] = `is_failed eq ${statusType === 'failed'}`
      }

      window.open(
        `${process.env.VUE_APP_API_ORDER_URL}/delivery-order/import/${
          this.$route.params.id
        }/result?${new URLSearchParams(params).toString()}`,
        '_self'
      )
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.mc-wizard) {
  display: inline-block;
  width: 100%;
}
</style>
